import { ConfigCatProvider, createFlagOverridesFromMap, OverrideBehaviour } from 'configcat-react';
import React, { useMemo } from 'react';

import { getDevFeatureFlags, getUrlOverrideFeatureFlags } from 'src/featureFlags/devFlags';

export const FeatureFlagProvider = ({ children }: { children: React.ReactNode }) => {
  const devFlags = useMemo(() => getDevFeatureFlags(), []);
  const urlFlags = useMemo(() => getUrlOverrideFeatureFlags(), []);
  const flagOverrides = useMemo(
    () =>
      createFlagOverridesFromMap({ ...devFlags, ...urlFlags }, OverrideBehaviour.LocalOverRemote),
    [devFlags, urlFlags],
  );

  return (
    <ConfigCatProvider
      sdkKey={process.env.REACT_APP_CONFIG_CAT_API_KEY || ''}
      options={{
        pollIntervalSeconds: 300,
        flagOverrides,
      }}
    >
      {children}
    </ConfigCatProvider>
  );
};
